import 'magnific-popup';
import 'slick-carousel';
// import moment from 'moment';

jQuery( document ).ready(function($) {

    $('.mfp-image').magnificPopup({
        type: 'image'
    });
    
    $('.scroll').on('click', function(e) {
        e.preventDefault();
        const scrollTop = $($(this).attr('href')).position().top;
        $('html, body').animate({ scrollTop });
    })

    $('.slider-videos').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
    });

    $('.seeall-btn').on('click', function(e){
        e.preventDefault();
        $('#events').addClass('seeall');
        $(this).hide();
    });

    // $.ajax( {
    //     url: 'https://rest.bandsintown.com/artists/Ashthon Jones/events?app_id=45PRESS_ashthon',
    //     method: 'GET',
    //     dataType: 'json',
    //     error: () => {
    //       alert( 'Error fetching events!' );
    //     },
    //     success: data => {
    //     const events = $( '#events' );
    //     let html = '';
    //     if ( data.length ) {
    //       for ( let event of data ) {
    //         let region = event.venue.region?event.venue.region:event.venue.country;
    //         let location = event.venue.city + ', ' + region;
    //         if ( location === ', ' ) {location = '';}
    //         if ( event.venue.name.toLowerCase() === 'streaming live' ) {location = 'Online';}
    //         html += '<div class="event">';
    //         html += '<div class="event-date">' + moment( event.datetime ).format( 'MMM DD, Y' ) + '</div>';
    //         html += '<div class="event-venue">' + event.venue.name + '</div>';
    //         html += '<div class="event-location">' + location + '</div>';
    //         html += '<div class="event-links">';
    //         for ( let offer of event.offers ) {
    //           html += '<a href="' + offer.url + '" target="_blank" class="btn">' + offer.type + '</a>';
    //         }
    //         html += '</div>';
    //         html += '</div>';
    //       }
    //       events.html( html );
    //       } else {
    //         events.html( '<p class="no-event">Check Back for Event Updates</p>' );
    //         $('.seeall-btn').hide();
    //       } 
    //     }
    //   });
    
});